import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { PRODUCTS_API, request } from '../services/api';
import { adminRequest } from '../services/adminApi';
export const defaultSite = { revision: 0, announcement: 'Envíos a todo el país · 15 días para cambios', slides: [], colors: [] };
const SiteContext = createContext({ settings: defaultSite, ready: false });
export const useSiteSettings = () => useContext(SiteContext);
export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(defaultSite), [ready, setReady] = useState(false);
  useEffect(() => { const abort = new AbortController();
    request(`${PRODUCTS_API}/site`, { signal: abort.signal }).then(data => { if (!abort.signal.aborted) setSettings(data); })
      .catch(() => {}).finally(() => { if (!abort.signal.aborted) setReady(true); });
    return () => abort.abort();
  }, []);
  const saveSettings = useCallback(async value => {
    const saved = await adminRequest('/admin/site', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(value) });
    setSettings(saved); return saved;
  }, []);
  return <SiteContext.Provider value={{ settings, ready, saveSettings }}>{children}</SiteContext.Provider>;
}
